import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const AuthenticationFormHeader: React.FC<AuthenticationFormHeaderProps> = ({ title, description }) => {
	return (
		<CardHeader>
			<CardTitle className="text-2xl">{title}</CardTitle>
			{description && <CardDescription>{description}</CardDescription>}
		</CardHeader>
	);
};

interface AuthenticationFormHeaderProps {
	title: string;
	description?: string;
}
